import script from "./itemV2ImageGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV2ImageGrid.vue?vue&type=script&setup=true&lang=ts"

import "./itemV2ImageGrid.vue?vue&type=style&index=0&id=2b2c21a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b2c21a6"]])

export default __exports__